export default "__VITE_ASSET__a75ddbc1__"